<template>
  <div>
    <v-card flat class="mb-5">
      <v-card-text>
        <v-list-item class="px-0">
          <v-list-item-content class="py-0">
            <v-row no-gutters>
              <v-col class="py-0" cols="12" md="5">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="secondary">
                    <v-icon dark>mdi-home</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 mt-3">
                    <div class="subtitle-2 black--text">
                      {{ $getDeepObj(initValue, 'detail.sekolah.data.nama') || '-' }}
                    </div>
                    <div class="caption">
                      <span>
                        <v-icon small left>mdi-map-marker</v-icon>
                        {{ $getDeepObj(initValue, 'detail.sekolah.data.alamat') || '-' }}
                      </span>
                      <br />
                      <span>
                        <v-icon small left>mdi-city</v-icon>
                        {{ $getDeepObj(initValue, 'detail.sekolah.data.m_jenjang.data.singkat') || '-' }}
                      </span>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col class="pt-0" cols="12" md="3">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0 mt-3">
                        <span class="caption">Kepala Sekolah</span>
                        <p class="ma-0">
                          <span>
                            {{ $getDeepObj(initValue, 'detail.ptk_kasek.data.nama') || '-' }}
                          </span>
                        </p>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col class="py-0" cols="12" md="4">
                <v-list-item class="px-0" v-if="$getDeepObj(meta, 'wakasek')">
                  <v-list-item-content class="py-0">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0 mt-3">
                        <span class="caption">Wakasek Kurikulum SMK</span>
                        <p class="ma-0">
                          <span>
                            {{ $getDeepObj(meta, 'wakasek.nama') || '-' }}
                          </span>
                        </p>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto" flat>
      <v-card-text>
        <template v-if="isP4tk">
          <div><h2 class="indigo--text">Pengawas Sekolah yang dipilih</h2></div>
          <div>
            <template v-if="(pengawas && $isObject(pengawas)) || (pengawasBaru && $isObject(pengawasBaru))">
              <v-list-item class="px-0 mb-3">
                <v-list-item-avatar color="secondary" size="40">
                  <v-icon dark style="font-size: 30px">mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0">
                  <v-row no-gutters>
                    <v-col cols="12" md="4">
                      <h2 class="body-1 secondary--text">{{
                        $getDeepObj(pengawasBaru, 'ptk.data.nama') || $getDeepObj(pengawas, 'ptk.data.nama') || '-'
                      }}</h2>
                      <div style="line-height: 1.2">
                        <label class="grey--text">No. UKG/SIMPKB ID:: </label>
                        {{
                          $getDeepObj(pengawasBaru, 'no_ukg') ||
                            $getDeepObj(pengawasBaru, 'ptk_id') ||
                            $getDeepObj(pengawas, 'ptk.data.no_ukg') ||
                            $getDeepObj(pengawas, 'ptk_id') ||
                            ''
                        }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-btn dark color="secondary" left @click="onSelectPengawas">
                        <v-icon left>mdi-pencil</v-icon> Ganti Pengawas
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-else>
              <v-btn dark color="secondary" left @click="onSelectPengawas">
                <v-icon left>mdi-account</v-icon> Pilih Pengawas
              </v-btn>
            </template>
          </div>
        </template>
        <div class="mt-8"><h2 class="indigo--text">Daftar Peserta Diklat</h2></div>
        <template v-for="(f, i) in items">
          <v-list-item :key="i" class="mx-0 px-0">
            <v-list-item-content>
              <v-row>
                <v-col cols="12" md="4">
                  <validation-provider name="Pilih Mapel" rules="required" v-slot="{ errors }">
                    <v-autocomplete
                      label="Pilih Mapel"
                      :items="i === 0 ? options.mapel : filteredOptions.mapel"
                      item-text="keterangan"
                      item-value="k_mapel_psp"
                      item-disabled="disabled"
                      v-model="form[i]['k_mapel_psp']"
                      outlined
                      single-line
                      dense
                      hide-details
                      :error-messages="errors"
                      :disabled="mode !== 'form'"
                    ></v-autocomplete>
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="8">
                  <validation-provider name="Pilih Guru" rules="required" v-slot="{ errors }">
                    <v-autocomplete
                      label="Pilih Guru"
                      :items="i === 0 ? options.guru : filteredOptions.guru"
                      item-text="nama"
                      item-value="ptk_id"
                      item-disabled="disabled"
                      v-model="form[i]['ptk_id']"
                      outlined
                      single-line
                      dense
                      hide-details
                      :error-messages="errors"
                      :disabled="mode !== 'form'"
                    >
                      <template v-slot:selection="data">
                        <v-list-item-content style="width: 100% !important;">
                          <h2 class="subtitle-1">{{ $getDeepObj(data, 'item.nama') || '-' }}</h2>
                          <p class="caption mb-0">
                            <span>
                              <v-icon small left>mdi-card-account-details-outline</v-icon>
                              {{ $getDeepObj(data, 'item.no_ukg') || '-' }}
                              <br />
                              <v-icon small left>mdi-home-variant</v-icon>
                              {{ $getDeepObj(data, 'item.satminkal') || '-' }}
                              -
                              {{ $getDeepObj(data, 'item.status') || '-' }}
                            </span>
                          </p>
                        </v-list-item-content>
                      </template>
                      <template v-slot:item="data">
                        <v-list-item-content class="full-width">
                          <h2 class="subtitle-1">{{ $getDeepObj(data, 'item.nama') || '-' }}</h2>
                          <p class="caption mb-0">
                            <span>
                              <v-icon small left>mdi-card-account-details-outline</v-icon>
                              {{ $getDeepObj(data, 'item.no_ukg') || '-' }}
                              <br />
                              <v-icon small left>mdi-home-variant</v-icon>
                              {{ $getDeepObj(data, 'item.satminkal') || '-' }}
                              -
                              {{ $getDeepObj(data, 'item.status') || '-' }}
                            </span>
                          </p>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-list-item-content>
            <v-list-item-action-text>
              <v-btn v-if="items.length > 1 && mode === 'form'" icon color="red" rounded @click="removeMapel(i)">
                <v-icon>mdi-close-circle</v-icon> </v-btn
              ><br />
              <v-btn v-if="items.length - 1 === i && mode === 'form'" icon color="blue" rounded @click="addMapel">
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
            </v-list-item-action-text>
          </v-list-item>
        </template>
      </v-card-text>
    </v-card>
    <Pengawas
      ref="pengawas"
      :type="type"
      action="kandidat-pengawas"
      :sekolah-id="detail && detail.sekolah_id"
      :masters="masters"
    />
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
export default {
  components: {
    Pengawas: () => import('../component/Sumber'),
    ValidationProvider,
  },
  props: {
    meta: {
      default: () => {},
    },
    masters: {
      type: Object,
      default: () => {},
    },
    initValue: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'form',
    },
    isP4tk: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      pengawas: null,
      pengawasBaru: null,
      mapel: [],
      guru: [],
      detail: {},
      items: [],
      form: [],
      deffForm: {
        k_mapel_psp: [],
        ptk_id: [],
      },
      cards: {
        mapel: {
          nama: 'keterangan',
          icon: 'mdi-book-open-page-variant',
        },
        guru: {
          nama: 'nama',
          icon: 'mdi-account',
        },
      },
    };
  },

  computed: {
    filteredOptions() {
      const mergeMapel = this.form.map((item) => item && item['k_mapel_psp']) || [];
      const mergePeserta = this.form.map((item) => item && item['ptk_id']) || [];

      const grupedMapel = this.mapel.filter((key) => {
        let getKelompok = '';
        if (mergeMapel.length) {
          const mapelIndex = this.mapel.findIndex((s) => s.k_mapel_psp === Number(mergeMapel[0]));
          const mapel = this.mapel[mapelIndex];
          getKelompok = (mapel && mapel.kelompok) || '';
        }
        return (key.kelompok || '') === getKelompok;
      });
      const mapMapel = (mergeMapel.length ? grupedMapel : this.mapel).map((item) => {
        const findIndex = mergeMapel.findIndex((s) => s === Number(item.k_mapel_psp));
        const jmlMapelSama = mergeMapel.filter((m) => m === Number(item.k_mapel_psp)).length;
        return {
          k_mapel_psp: item && item.k_mapel_psp,
          keterangan: item && item.keterangan,
          disabled: findIndex > -1 && jmlMapelSama >= item.maks_guru,
        };
      });

      const mapPeserta = this.guru.map((key) => {
        const findIndex = mergePeserta.findIndex((s) => s === key.ptk_id);
        return {
          ptk_id: key.ptk_id,
          nama: key.nama,
          no_ukg: key.no_ukg || key.ptk_id,
          disabled: findIndex > -1,
          satminkal: this.$isObject(key.ptk_sekolah) ? 'Satminkal' : 'Non Satminkal',
          status: key.m_pegawai && key.m_pegawai.is_pns ? 'PNS' : 'Non PNS',
        };
      });

      return { mapel: mapMapel || [], guru: mapPeserta || [] };
    },

    options() {
      const mapMapel = this.mapel.map((item) => {
        return {
          k_mapel_psp: item && item.k_mapel_psp,
          keterangan: item && item.keterangan,
        };
      });
      const mapPeserta = this.guru.map((item) => {
        return {
          ptk_id: item.ptk_id,
          nama: item.nama,
          no_ukg: item.no_ukg || item.ptk_id,
          satminkal: this.$isObject(item.ptk_sekolah) ? 'Satminkal' : 'Non Satminkal',
          status: item.m_pegawai && item.m_pegawai.is_pns ? 'PNS' : 'Non PNS',
        };
      });

      return { mapel: mapMapel || [], guru: mapPeserta || [] };
    },
  },

  methods: {
    reset() {
      this.$set(this, 'form', []);
      this.$set(this, 'items', []);
      this.$set(this, 'pengawas', null);
      this.$set(this, 'pengawasBaru', null);
    },

    initForm(value) {
      this.reset();
      const psp_diklats = this.$getDeepObj(value, 'detail.psp_diklat_gurus.data') || [];
      this.detail = this.$getDeepObj(value, 'detail') || {};
      this.mapel = this.$getDeepObj(value, 'mapel') || [];
      this.guru = this.$getDeepObj(value, 'guru') || [];

      if (psp_diklats.length) {
        this.$set(this, 'items', []);
        psp_diklats.forEach((key) => {
          this.items.push({ form: this.deffForm });
          this.form.push({ k_mapel_psp: key.k_mapel_psp, ptk_id: key.ptk_id });
        });
      } else {
        this.$set(this, 'items', []);
        this.items.push({ form: this.deffForm });
        this.form.push({ k_mapel_psp: '', ptk_id: '' });
      }

      // init data pengawas
      const pengawases = this.$getDeepObj(value, 'detail.psp_diklat_pengawases.data') || [];
      const pengawas = pengawases[pengawases.length ? pengawases.length - 1 : 0] || {};
      this.$set(this, 'pengawas', pengawas || null);
    },

    onSelectPengawas() {
      this.$refs.pengawas.open('Pilih Pengawas').then((pengawas) => {
        this.pengawasBaru = pengawas;
      });
    },

    addMapel() {
      this.items.push({ form: this.deffForm });
      this.form.push({ k_mapel_psp: '', ptk_id: '' });
    },

    removeMapel(i) {
      this.items.splice(i, 1);
      this.form.splice(i, 1);
    },

    getValue() {
      if (this.isP4tk) {
        return {
          diklat_gurus: this.form,
          diklat_pengawas: {
            ptk_id: (this.pengawasBaru && this.pengawasBaru.ptk_id) || (this.pengawas && this.pengawas.ptk_id) || '',
          },
        };
      }

      return this.form;
    },
  },

  watch: {
    initValue: 'initForm',
  },
};
</script>
